import GuidedPracticeCard from './GuidedPracticeCard';

export default GuidedPracticeCard;
